/*eslint no-unused-vars: [1, {args: "after-used"}] */
import { createSelector } from "reselect";
import find from "lodash/find";
import makeGetAllHotspotEntityDefinitions from "selectors/hotspots/makeGetAllHotspotEntityDefinitions";

const getHotspotId = (_, ownProps) => ownProps.hotspotId;
const getStoryEntities = (state) => state.story.entities;

// This creates a new selector for each source that wants one. See the "Sharing Selectors Across
// Multiple Components" section of http://redux.js.org/docs/recipes/ComputingDerivedData.html
const makeGetHotspotEntity = () => {
  const getAllHotspotEntityDefinitions = makeGetAllHotspotEntityDefinitions();

  return createSelector(
    [getAllHotspotEntityDefinitions, getHotspotId, getStoryEntities],
    (allHotspotEntityDefinitions, hotspotId, storyEntities) => {
      const hotspotIdentifier = find(allHotspotEntityDefinitions, {
        id: hotspotId,
      });
      return storyEntities[hotspotIdentifier.schema][hotspotIdentifier.id];
    },
  );
};

export default makeGetHotspotEntity;
